import * as yup from 'yup';

import { usePkwInputStore } from '@/features/Sparten/pkw/useInputStore';
import { assistenzsysteme } from '@/features/Sparten/shared/schema/kfz/assistenzSystemeSchema/assistenzSystemeSchema';

export const validateZulassungsdatumAufVN = (value: Date | null): boolean => {
  const store = usePkwInputStore();

  if (value == null || store.fahrzeug.erstbesitzer) {
    return true;
  }

  const zulassung = store.fahrzeug.erstzulassung;

  return !(zulassung !== null && value < zulassung);
};

export const minimumErstzulassungsdatum = new Date('1900-01-01');
export const validateErstzulassungsdatum = (value: Date | null): boolean =>
  value === null || value >= minimumErstzulassungsdatum;

export const fahrzeugSchema = yup.object({
  assistenzsysteme,
  antriebsart: yup.string().default(''),
  auslandsnutzung: yup.string().default(''),
  erstbesitzer: yup.boolean().default(false),
  erstzulassung: yup
    .date()
    .nullable()
    .default(null)
    .required()
    .test(
      'validErstzulassungsDatum',
      'Darf nicht vor 01.01.1900 liegen',
      validateErstzulassungsdatum,
    ),
  erstmaligeZulassungAufVN: yup
    .date()
    .nullable()
    .default(null)
    .test(
      'validZulassungsDatum',
      'Darf nicht vor Erstzulassung liegen.',
      validateZulassungsdatumAufVN,
    )
    .when('erstbesitzer', {
      is: (val: boolean) => !val,
      then: yup.date().required(),
    }),
  fahrleistung: yup.number().default(0).min(100).required(),
  finanzierungsart: yup.string().default(''),
  hsn: yup.string().default('').required(),
  isAlsBetriebsausgabeAnerkannt: yup.boolean().default(false),
  kilometerstand: yup.number().default(0).min(1).required(),
  leistung: yup
    .number()
    .default(0)
    .required()
    .min(1, 'Die Leistung in kW muss mindestens 1 betragen'),
  neuwert: yup.number().default(0).min(1).required(),
  nutzungsart: yup.string().default(''),
  stellplatz: yup.string().default(''),
  tsn: yup.string().default('').required(),
});
